module.exports = __webpack_public_path__ + "img/arrowup.c533a764.svg";